import React, { useState } from "react";
import ItemNameFinder from "./Main";
  
const Demo = () => {
  const [value, setValue] = useState(null)

  return (
    <>
      <ItemNameFinder
        vendor_id={74}
        default_value={738424}
        value={value}
        onChange={(val) => setValue(val)}
      />
      <br/>
      {value && <ul>
        <li>ID: {value.id}</li>
        <li>Item Number: {value.item_number}</li>
        <li>Name: {value.name}</li>
      </ul>}
    </>
  )
}

export default Demo;
